export default __webpack_public_path__ + "static/media/kr.d034b4d7.svg";